import Vue from 'vue'

export const store = Vue.observable({
    noConnect: {
        normal: {
            shit: {
               wrapper: `active:bgc:#333333; hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; dis:f; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); cursor:p;  miw:124px; font:14px; letter-s:0.5px; bgc:#696969; radius:13px; h:24px; lh:22px;`,
               button: 'border-top-left-radius:14px; border-bottom-left-radius:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
               split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
               icon: 'border-top-right-radius:14px; border-bottom-right-radius:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
               href: 'el-icon-caret-bottom'
            }
        },
        'select/0': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
                icon: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        },
        'select/1': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
                icon: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        }
    },
    connected: {
        normal: {
            shit: {
               wrapper: `active:bgc:#333333; hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; dis:f; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); cursor:p;  miw:124px; font:14px; letter-s:0.5px; bgc:#696969; radius:13px; h:24px; lh:22px;`,
               button: 'border-top-left-radius:14px; border-bottom-left-radius:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
               split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
               icon: 'border-top-right-radius:14px; border-bottom-right-radius:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
               href: 'el-icon-caret-bottom'
            }
        },
        'select/0': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
                icon: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        },
        'select/1': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
                icon: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        }
    },
    quickConnected: {
        normal: {
            shit: {
               wrapper: `active:bgc:#333333; hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; dis:f; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); cursor:p;  miw:124px; font:14px; letter-s:0.5px; bgc:#696969; radius:13px; h:24px; lh:22px;`,
               button: 'border-top-left-radius:14px; border-bottom-left-radius:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
               split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
               icon: 'border-top-right-radius:14px; border-bottom-right-radius:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
               href: 'el-icon-caret-bottom'
            }
        },
        'select/0': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
                icon: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        },
        'select/1': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6)!;',
                icon: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        }
    },
    noGetSimulatorKey: {
        normal: {
            shit: {
               wrapper: `active:bgc:#333333; hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; dis:f; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); cursor:p;  miw:124px; font:14px; letter-s:0.5px; bgc:#696969; radius:13px; h:24px; lh:22px;`,
               button: 'border-top-left-radius:14px; border-bottom-left-radius:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
               split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6);',
               icon: 'border-top-right-radius:14px; border-bottom-right-radius:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; active:bgc:#272727;',
               href: 'el-icon-caret-bottom'
            }
        },
        'select/1': {
            shit: {
                wrapper: `bgc:#333333; dis:f; cursor:p;  miw:124px; font:14px; letter-s:0.5px; radius:13px; h:24px; lh:22px;`,
                button: 'hover:bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; br:n; btlr:14px; bblr:14px; dis:i-b; miw:90px; px:26px; text-a:c; c:#0ed3ff; font-w:500; active:bgc:#272727;',
                split: 'h:100%; dis:i-b; w:1px; bgc:rgba(14, 211, 255, 0.6)!;',
                icon: 'bc:rgba(14, 211, 255, 0.6); border: solid 1px transparent; bl:n; btrr:14px; bbrr:14px; w:34px; h:100%; dis:b; mr:0px!; pl:3px; font:22px; c:#0ed3ff; bgc:#272727;',
                href: 'el-icon-caret-bottom'
            }
        }
    },
    public: {
        normal: {
            shit: {
               wrapper: `active:bgc:#333333; border: solid 1px transparent; dis:f; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); cursor:p;  miw:124px; font:14px; letter-s:0.5px; bgc:#696969; radius:13px; h:24px; lh:22px;`,
               button: 'border-top-left-radius:14px; border-bottom-left-radius:14px; dis:i-b; w:58px; pl:28px; c:#0ed3ff; font-w:500; active:bgc:#272727;',
               icon: 'border-top-right-radius:14px; border-bottom-right-radius:14px; w:38px; h:100%; dis:b; mr:0px!;  font:22px; c:#0ed3ff; active:bgc:#272727;',
               href: 'el-icon-caret-right'
            }
        }
    },
    normalSet: {
        playList: [
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_0"), is: 1, checked: true },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_1"), is: 4, checked: false, disabled: true },
        ],
    },
    quickSet: {
        playList: [
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_2"), is: 1, checked: true },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_3"), is: 4, checked: false },
        ],
    },
    set: {
        playList: [
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_4"), is: 1, checked: true },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_5"), is: 4, checked: false },
        ],
    },
    seted: {
        playList: [
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_6"), is: 1, checked: true, disabled: false },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_7"), is: 2, checked: false, disabled: false },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_8"), is: 3, checked: false, disabled: false },
            { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/observable.js_9"), is: 4, checked: false, disabled: false },
        ],
    },
    currentShit: 'quickConnected.normal.shit',
    currentPlayList: 'normalSet',
    currentChecked: 1,
    nosetChecked: 1,
    showIs: false,
    status: 0,
})

export const mutations = {
    status (payload) {
        Object.assign(store, payload)
    },
    nosetChecked (payload) {
        Object.assign(store, payload)
    },
    showIs (payload) {
        Object.assign(store, payload)
    },
    currentShit (payload) {
        Object.assign(store, payload)
    },
    playList (payload) {
        Object.assign(store, payload)
    },
    currentChecked (payload) {
        Object.assign(store, payload)
        if (store.currentChecked === 1) {
            this.allStatus()
        }
    },
    currentPlayList (payload) {
        Object.assign(store, payload)
    },
    
    addNosetDefultValue () {
       const list = store.set.playList.map(item => {
            if (item.is === 1) Object.assign(item, { checked: true })
            return item
        })
        Object.assign(store.set, { playList: list })
        store.nosetChecked = 1
        
    },
    nosetPlayListClear () {
        const list = store.set.playList.map(item => {
            Object.assign(item, { checked: false, disabled: false })
            return item
        })
        Object.assign(store.set, { playList: list })
    },

    addActiveSetStatusOfNoset () {
        const list = store.set.playList.map(item => {
            if (item.is === 4) Object.assign(item, { checked: true, disabled: false })
            return item
        })
        Object.assign(store.set, { playList: list })
        store.nosetChecked = 4
    },
    addActiveSetStatusOfSeted () {
        const list = store.seted.playList.map(item => {
            if (item.is === 4) Object.assign(item, { checked: true, disabled: false })
            return item
        })
        Object.assign(store.seted, { playList: list })
        store.currentChecked = 4
    },

    allStatus () {
        this.nosetPlayListClear()
        this.addNosetDefultValue()
        this.clearOfAllValue()
        this.addDefaultValue()
    },
    allSetStatus () {
        this.clearOfAllValue()
        this.nosetPlayListClear()
        this.addActiveSetStatusOfNoset()
        this.addActiveSetStatusOfSeted()
    },

    addTeacher () {
       store.seted.playList[1].checked = true
       store.currentChecked = 2
    },
    addStudent () {
       store.seted.playList[2].checked = true
       store.currentChecked = 3
    },

    addcommonList () {
        const list = store.seted.playList.map(item => {
            Object.assign(item, { disabled: false })
            return item
        })
        Object.assign(store.seted, { playList: list })
    },
    addDesabledOfTeacher () {
        const list = store.seted.playList.map(item => {
            if (item.is === 2) Object.assign(item, { checked: false, disabled: true })
            return item
        })
        Object.assign(store.seted, { playList: list })
    },
    addDesabledOfStudent () {
        const list = store.seted.playList.map(item => {
            if (item.is === 3) Object.assign(item, { checked: false, disabled: true })
            return item
        })
        Object.assign(store.seted, { playList: list })
    },
    addDesabledOfAll () {
        const list = store.seted.playList.map(item => {
           if (item.is === 4) {
               Object.assign(item, { checked: false, disabled: false })
           } else {
             Object.assign(item, { checked: false, disabled: true })
           }
            return item
        })
        Object.assign(store.seted, { playList: list })
    },
    clearOfAllValue () {
        const list = store.seted.playList.map(item => {
            Object.assign(item, { checked: false, disabled: false })
            return item
        })
        Object.assign(store.seted, { playList: list })
    },
    addDefaultValue () {
       const judge = store.seted.playList.some(sm => sm.checked)
       if (!judge) {
            store.seted.playList[0].checked = true
            store.currentChecked = 1
       }
    },
    clearCurrentChecked () {
        Object.assign(store, { currentChecked: 0 })
    }
}
